import { FileUploadOutlined as FileUploadOutlinedIcon, ShareOutlined as ShareOutlinedIcon } from '@mui/icons-material';
import { CHILD_TEAM_ACTION_COPY } from './childTeamActionConfig';

export const DASHBOARD_ACTION_IDS = {
  ADD_CHILD: 'add-child',
  VIEW_CARE_TEAM: 'view-care-team',
  INVITE_CAREGIVER: 'invite-caregiver',
  START_CHAT: 'start-chat',
  PREP_FOR_THERAPY: 'prep-for-therapy',
  IMPORT_LOGS: 'import-logs',
  EDIT_CHILD: 'edit-child',
  DELETE_CHILD: 'delete-child',
  SHARE: 'share',
  IMPORT: 'import',
};

export const DASHBOARD_ACTION_DEFINITIONS = {
  [DASHBOARD_ACTION_IDS.SHARE]: {
    id: DASHBOARD_ACTION_IDS.SHARE,
    label: 'Share',
    menuLabel: CHILD_TEAM_ACTION_COPY.shareCareSummary,
    ariaLabel: 'Share care summary',
    icon: ShareOutlinedIcon,
  },
  [DASHBOARD_ACTION_IDS.IMPORT]: {
    id: DASHBOARD_ACTION_IDS.IMPORT,
    label: 'Import',
    menuLabel: CHILD_TEAM_ACTION_COPY.importPastData,
    ariaLabel: 'Import past data',
    icon: FileUploadOutlinedIcon,
  },
};

export const DASHBOARD_ACTION_ORDER = [
  DASHBOARD_ACTION_IDS.SHARE,
  DASHBOARD_ACTION_IDS.IMPORT,
];

export const getDashboardActionDefinition = (actionId) => DASHBOARD_ACTION_DEFINITIONS[actionId] || null;
